export const DS_TOOLTIP_CSS_VARS_PREFIX = 'tooltip';
export const DS_TOOLTIP_CUSTOMIZABLE_PARAMS = ['backgroundColor', 'textColor', 'boxShadow'];
